/**
 * Capture the ARIA / accessibility surface of an element into a single
 * compact string for the AFS `accessibility` field.
 */
const ARIA_ATTRS = [
    "role",
    "aria-label",
    "aria-labelledby",
    "aria-describedby",
    "aria-hidden",
    "aria-disabled",
    "aria-expanded",
    "aria-haspopup",
    "aria-controls",
    "aria-pressed",
    "aria-checked",
    "aria-current",
    "aria-live",
    "tabindex",
    "title",
];
export const getAccessibility = (el) => {
    const pairs = [];
    for (const attr of ARIA_ATTRS) {
        if (el.hasAttribute(attr)) {
            const value = el.getAttribute(attr);
            if (value !== null) {
                pairs.push(`${attr}="${value}"`);
            }
        }
    }
    return pairs.join(" ");
};
//# sourceMappingURL=accessibility.js.map